import { classNamePrefix } from '../globals';

export function renderDescription (description: string, id?: string) {
    const className = classNamePrefix + '-description';

    const descriptionElement = document.createElement('p');
    descriptionElement.classList.add(className);
    descriptionElement.innerHTML = description;

    if (id) {
        descriptionElement.id = id;
    }

    return descriptionElement;
}